import * as ACT from '../actions/serviceActions';

export function service(state = {}, action) {
    switch (action.type) {


        case ACT.SERVICE_GET_ITEM:
            return {
                ...state,
                getItem: action.data,
            };
        case ACT.SERVICE_SET_ITEM:
            return {
                ...state,
                targetItem: action.data,
            };
        case ACT.SERVICE_ADD_ITEM:
            return {
                ...state,
                addItem: action.data,
            };
        case ACT.SERVICE_SET_ALL:
            return {
                ...state,
                list: action.data,
            };


        case ACT.SERVICE_FIELD_ERROR:
            if (state.fieldsError)
                var fieldsErrorPushed = state.fieldsError;
            else
                fieldsErrorPushed = {};
            fieldsErrorPushed[action.fieldName] = (action.fieldData != {}) ? action.fieldData : {err: true};


            return {
                ...state,
                fieldsError: fieldsErrorPushed,
                formError: true,
            };
        case ACT.SERVICE_FIELD_RESET_ERROR:
            return {
                ...state,
                fieldsError: {},
                formError: false,
            };


        default:
            return state
    }
};
